export default __webpack_public_path__ + "static/media/place-image.dc83665c.webp";